import styled from 'styled-components';

export const Results = styled.p``;
